/* Gharkit storefront helpers (no dependencies, ~1.5 KB). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll reveal for .gk-reveal (Dawn's own .scroll-trigger stays as is) */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gk-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* 2. Dispatch cut-off countdown (Asia/Kolkata, UTC+5:30, no DST) */
  function initCutoff() {
    var rows = document.querySelectorAll('[data-gk-cutoff]');
    if (!rows.length) return;
    function tick() {
      var now = new Date();
      var istMs = now.getTime() + now.getTimezoneOffset() * 60000 + 330 * 60000;
      var ist = new Date(istMs);
      rows.forEach(function (row) {
        var hour = parseInt(row.getAttribute('data-gk-cutoff'), 10) || 18;
        var cut = new Date(ist.getTime()); cut.setHours(hour, 0, 0, 0);
        var diff = cut - ist;
        var out = row.querySelector('[data-gk-countdown]');
        var sunday = ist.getDay() === 0;
        if (diff <= 0 || sunday) {
          var txt = row.querySelector('.gk-urgency__text');
          if (txt) txt.textContent = row.getAttribute('data-gk-after');
          return;
        }
        var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
        if (out) out.textContent = (h ? h + 'h ' : '') + m + 'm';
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  function init() { initReveal(); initCutoff(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCutoff(); });
  /* Product info re-renders on variant change */
  document.addEventListener('variant:change', function () { setTimeout(initCutoff, 50); });
})();
/* Clamp long product descriptions behind a "Read more" button */
(function () {
  function clamp() {
    document.querySelectorAll('.product__description:not([data-gk-clamped])').forEach(function (el) {
      el.setAttribute('data-gk-clamped', '1');
      if (el.scrollHeight < 460) return;
      el.classList.add('gk-clamp');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gk-more'; b.setAttribute('aria-expanded', 'false');
      b.textContent = 'Read full description';
      b.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? 'Show less' : 'Read full description';
        if (!open) el.scrollIntoView({ block: 'nearest' });
      });
      el.insertAdjacentElement('afterend', b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clamp); else clamp();
})();
/* Landing-page CTAs ([data-gk-cod]) open the main product's Releasit COD form */
(function () {
  function codButton() {
    var list = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < list.length; i++) if (list[i].offsetHeight > 0) return list[i];
    return null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-gk-cod]');
    if (!t) return;
    e.preventDefault();
    var c = codButton();
    if (c) { c.click(); return; }
    var atc = document.querySelector('.product__info-container [id^="ProductSubmitButton-"]');
    if (atc && atc.offsetHeight > 0 && !atc.disabled) { atc.click(); return; }
    var info = document.querySelector('.product__info-container');
    if (info) info.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
